export const firebaseConfig = {
  apiKey: "AIzaSyCokYIoyrkPyipPYwmo7oiFbEVz60jb71A", // Replace with your actual keys if different
  authDomain: "blackboxmi-prod.firebaseapp.com",
  projectId: "blackboxmi-prod",
  storageBucket: "blackboxmi-prod.firebasestorage.app",
  messagingSenderId: "1088098501117",
  appId: "1:1088098501117:web:eee9b916ce0236066c1994"
};